import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { Loader2 } from "lucide-react";
import { ASSETS, api } from "@/lib/api";

export default function RsvpPass() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api.get(`/reservations/${id}/pass`).then(({ data }) => setState({ data })).catch(() => setState({ notFound: true }));
  }, [id]);

  const r = state.data;
  return (
    <div data-testid="rsvp-pass-page" className="min-h-screen bg-[var(--trio-bg)] flex flex-col items-center justify-center px-6 py-14 text-center">
      <img src={ASSETS.logo} alt="Trio" className="h-12 w-auto mb-6" />
      {state.loading && <Loader2 className="w-10 h-10 animate-spin text-[var(--trio-primary)]" />}
      {state.notFound && <h1 className="font-display uppercase text-3xl">Pass not found</h1>}
      {r && (
        <div className="max-w-sm w-full">
          {params.get("new") && (
            <h1 data-testid="rsvp-pass-new" className="font-display uppercase text-4xl tracking-tight mb-2">You're On The List!</h1>
          )}
          <div className="border-2 border-dashed border-[var(--trio-primary)] p-5 bg-white">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[var(--trio-primary)] font-bold mb-1">Screenshot This Now</div>
            <p className="text-xs text-[var(--trio-muted)] mb-4">This is your check-in pass. Show this QR code at the door.</p>
            {r.valid ? (
              <QRCodeCanvas data-testid="rsvp-pass-qr" value={`${window.location.origin}/rsvp/verify/${r.id}`} size={200} level="M" includeMargin className="mx-auto" />
            ) : (
              <div data-testid="rsvp-pass-cancelled" className="py-10 text-red-700 font-bold uppercase tracking-widest">Cancelled</div>
            )}
            <div data-testid="rsvp-pass-name" className="mt-3 text-sm font-semibold text-black">{r.name}</div>
            <div className="text-xs text-[var(--trio-muted)]">
              Party of {r.party_size} · {r.event_title || "Table reservation"}
            </div>
            <div className="text-xs text-[var(--trio-muted)]">{r.date}{r.time ? ` · ${r.time}` : ""}</div>
            <div className="text-[10px] text-[var(--trio-muted)] mt-1 font-mono">#{r.id.slice(0, 8).toUpperCase()}</div>
          </div>
          <Link to="/" data-testid="rsvp-pass-home" className="inline-block mt-6 text-xs uppercase tracking-widest underline">Back to Trio</Link>
        </div>
      )}
    </div>
  );
}
